import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const collectionNames = {
  "boredapeyachtclub": "Apes",
  "cryptopunks": "CryptoPunks",
  "art-blocks": "Art Blocks",
  "azuki": "Azuki",
  "ens": "ENS",
  "cryptokitties": "CryptoKitties",
   "superrare": "SuperRare",
   "chromie-squiggle-by-snowfro": "Chromie Squiggle",
   "mutant-ape-yacht-club": "Mutant Apes",
   "rarible": "Rarible",
  // Add other collection mappings here
};



const TopNFTCollections = () => {
  const [collections, setCollections] = useState([]);

  useEffect(() => {
    const fetchCollections = async (retryCount = 0) => {
      try {
        // Check sessionStorage for cached data
        const cachedData = sessionStorage.getItem("nft-collections");
        if (cachedData) {
          const parsedData = JSON.parse(cachedData);
          //console.log("Using cached NFT collections:", parsedData);
          setCollections(parsedData);
          return; // Exit early if cache is available
        }

        const response = await axios.get('/api/nftdata');
        //console.log('NFT Response data:', response.data); 
        const latestData = response.data.latestData;
        const aggregatedMarketCaps = response.data.aggregatedMarketCaps;
        const changes = response.data.changes;

        const collectionsWithChanges = Object.keys(latestData).map(collection => {
            const collectionData = latestData[collection];
            const collectionChanges = changes[collection];
            return { ...collectionData, ...collectionChanges, name: collectionNames[collection] || collection };
        });

        collectionsWithChanges.sort((a, b) => b.market_cap - a.market_cap);
        const topCollections = collectionsWithChanges.slice(0, 5);

        // Save to sessionStorage
        sessionStorage.setItem("nft-collections", JSON.stringify(topCollections));

        setCollections(topCollections);
      } catch (error) {
        //console.error('Error fetching collections:', error);
        if (retryCount < 3) {
          setTimeout(() => fetchCollections(retryCount + 1), 200); // Retry after 2 seconds
        }
      }
    };

    fetchCollections();
  }, []);

  

  const toLocaleString = (num) => {
    return Number(num || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  
  return (
    <div className="py-4 border-t w-full" style={{ borderColor: 'var(--border-color)', }}>
      {collections.map(collection => {
        const change = collection.marketCapChange;
        const isIncrease = change > 0;
        const isDecrease = change < 0;
        let textColor = 'dark:text-white'; // Default to white
        
        if (isIncrease) {
          textColor = "text-green-500";
        } else if (isDecrease) {
          textColor = "text-red-500";
        }

        return (
          <Link to="/nftdata" key={collection.name}>
            <div className="flex justify-between compatible-link w-full">
              <h3 className="flex-grow">{collection.name}</h3>
              <p className={textColor + " flex-shrink-0"}>
                ◊{toLocaleString(collection.market_cap)}
              </p>
            </div>
          </Link>
        );
      })}
    </div>
  );
};

export default TopNFTCollections;
